import React, { useState, useEffect, useContext } from "react";
import { Form, Row, Col, Button, Image, Card } from "react-bootstrap";
import { Stepper, Step } from "react-form-stepper";
import { useHistory } from "react-router";
import {
  BASE_URL_API,
  BASE_URL_API_TRANXT_API,
  BASE_URL_PAYNOW,
  BASE_URL_APISERVICES,
} from "../../utils/Constants";
import cogoToast from "cogo-toast";
import swal from "sweetalert";
import { uniqueID2 } from "../../utils/utilFuctions";
import { generateHashKey2 } from "../../utils/utilFuctions";
import DatePicker from "react-datepicker";
import { ContextMenuTrigger } from "react-contextmenu";
import { GlobalContext } from "../../Context/GlobalState";
import { adminAuth, basicAuth } from "../../config";
import { validatePanCard } from "../../utils/utilFuctions";
import { NoDataFound } from "../bbps-report/BBPSReportTable";
import { excelMapping, ExportToExcel } from "../../utils/utilFuctions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { set } from "react-hook-form";
import UserLien from "../UserLien/UserLien";
import AepsOnboarding from "../user-view/AepsOnboarding";
import CommercialsSetup from "../user-view/CommercialsSetup";
import { offsetArr } from "../../utils/CommonConfig";
import { Modal } from "react-bootstrap";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";

const EditUserDetails = ({ agentId, us_code, usr_mobile }) => {
  const { username1, password1 } = adminAuth;
  const [activeTab, setActiveTab] = useState(0);
  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const [clickedImageURL, setClickedImageURL] = useState("");
  const [personalDetails, setPersonalDetails] = useState({});
  const [aepsSettlementAccounts, setAepsSettlementAccounts] = useState([]);
  const [pgSettlementAccounts, setPgSettlementAccounts] = useState([]);

  const ProfileDetails = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
        );
      console.log("test1");

      var raw = JSON.stringify({
        UserID: agentId,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.GET_USER_VIEW_PROFILE}`,
        requestOptions
      );
      const data = await res.json();

      if (data.responseCode === "00") {
        setPersonalDetails(data.data);
        setAepsSettlementAccounts(data.aepsSettlementBanks);
        console.log("Data mapped successfully");
      } else {
        swal(
          "User Not Found",
          "Please Enter Valid ID Or Mobile number",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    ProfileDetails();
  }, [agentId, usr_mobile]);

  return (
    <div className="px-4" style={{ fontFamily: "auto" }}>
      {clickedImageURL && (
        <div className="image-overlays" onClick={() => setClickedImageURL("")}>
          <img src={clickedImageURL} alt="Clicked" />
        </div>
      )}

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          gap: "20px",
        }}
      >
        <div
          defaultActiveKey="profile"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            width: "200px",
            border: "none",
            padding: "10px",
            borderRadius: "5px",
            backgroundColor: "#fff",
          }}
        >
          <div
            style={{
              padding: "10px",
              cursor: "pointer",
              backgroundColor: activeTab === 0 ? "#d3d3d3" : "#ffffff",
              color: "black",
              marginBottom: "5px",
              borderRadius: "3px",
              textAlign: "center",
              width: "100%",
              border: "none",
            }}
            onClick={() => handleTabClick(0)}
          >
            Personal Information
          </div>
          <div
            style={{
              padding: "10px",
              cursor: "pointer",
              backgroundColor: activeTab === 1 ? "#d3d3d3" : "#ffffff",
              color: "black",
              marginBottom: "5px",
              borderRadius: "3px",
              textAlign: "center",
              width: "100%",
              border: "none",
            }}
            onClick={() => handleTabClick(1)}
          >
            Network Information
          </div>
          <div
            style={{
              padding: "10px",
              cursor: "pointer",
              backgroundColor: activeTab === 2 ? "#d3d3d3" : "#ffffff",
              color: "black",
              marginBottom: "5px",
              borderRadius: "3px",
              textAlign: "center",
              width: "100%",
              border: "none",
            }}
            onClick={() => handleTabClick(2)}
          >
            Bank Information
          </div>
          <div
            style={{
              padding: "10px",
              cursor: "pointer",
              backgroundColor: activeTab === 3 ? "#d3d3d3" : "#ffffff",
              color: "black",
              marginBottom: "5px",
              borderRadius: "3px",
              textAlign: "center",
              width: "100%",
              border: "none",
            }}
            onClick={() => handleTabClick(3)}
          >
            Document Images
          </div>
          <div
            style={{
              padding: "10px",
              cursor: "pointer",
              backgroundColor: activeTab === 4 ? "#d3d3d3" : "#ffffff",
              color: "black",
              marginBottom: "5px",
              borderRadius: "3px",
              textAlign: "center",
              width: "100%",
              border: "none",
            }}
            onClick={() => handleTabClick(4)}
          >
            Lein Amount
          </div>
          <div
            style={{
              padding: "10px",
              cursor: "pointer",
              backgroundColor: activeTab === 5 ? "#d3d3d3" : "#ffffff",
              color: "black",
              marginBottom: "5px",
              borderRadius: "3px",
              textAlign: "center",
              width: "100%",
              border: "none",
            }}
            onClick={() => handleTabClick(5)}
          >
            Aeps Settings
          </div>
          <div
            style={{
              padding: "10px",
              cursor: "pointer",
              backgroundColor: activeTab === 6 ? "#d3d3d3" : "#ffffff",
              color: "black",
              marginBottom: "5px",
              borderRadius: "3px",
              textAlign: "center",
              width: "100%",
              border: "none",
            }}
            onClick={() => handleTabClick(6)}
          >
            Commercials - Setup
          </div>
        </div>

        <div style={{ flex: 1 }}>
          {activeTab === 0 && (
            <div>
              <PersonalInfo agentId={agentId} details={personalDetails} />
            </div>
          )}
          {activeTab === 1 && (
            <div>
              <NetworkInfo agentId={agentId} details={personalDetails} />
            </div>
          )}
          {activeTab === 2 && (
            <div>
              <BankInfo
                details={{
                  aepsSettlementAccounts,
                  pgSettlementAccounts,
                  personalDetails,
                }}
                agentId={agentId}
                refresh={ProfileDetails}
              />
            </div>
          )}
          {activeTab === 3 && (
            <div>
              <ImagesData details={personalDetails} />
            </div>
          )}
          {activeTab === 4 && (
            <div>
              <UserLien details={personalDetails} />
            </div>
          )}
          {activeTab === 5 && (
            <div>
              <AepsOnboarding agentId={agentId} details={personalDetails} />
            </div>
          )}
          {activeTab === 6 && (
            <div>
              <CommercialsSetup agentId={agentId} details={personalDetails} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditUserDetails;

const PersonalInfo = ({ details, agentId, usr_mobile }) => {
  const [formValues, setFormValues] = useState(details);
  const [modalOpen2, setModalOpen2] = useState(false);
  const [modalOpen3, setModalOpen3] = useState(false);

  
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const history = useHistory();

  const [State, setState] = useState("");
  const [City, setCity] = useState("");

  const [uploadedDocs, setUploadedDoc] = useState({
    profile: false,
    POI: false,
    POA_Front: false,
    POA_Back: false,
    sign: false,
    gstdoc: false,
  });
  const [clickedImageURL, setClickedImageURL] = useState("");
  const userId = JSON.parse(localStorage.getItem("kyc"));

  const Datehandler = (date) => {
    setFormValues({ ...formValues, DOB: date });
  };

  const imagePath = `${BASE_URL_API}/users_kyc_doc`;

  const dateToStr = (date) =>
    `${date.getFullYear()}-${
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1
    }-${date.getDate() < 10 ? "0" + date.getDate() : date.getDate()}`;

  const pincodeData = (pincode, type) => {
    console.log({ pincode, type });
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      pincode: pincode,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      setTransactionLoaderState(true);
      fetch(
        `${BASE_URL_API}${API_ENDPOINTS.PIN_DATA}`,

        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.length > 0) {
            setCity(result[0].city);
            setState(result[0].state);
            if (type == "1") {
              setFormValues({
                ...formValues,
                City: result[0].city,
                State: result[0].state,
              });
            } else if (type == "2") {
              setFormValues({
                ...formValues,
                ShopCity: result[0].city,
                ShopState: result[0].state,
              });
            }
          }
          setTransactionLoaderState(false);
        })
        .catch((err) => {
          setTransactionLoaderState(false);
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    if (formValues.Pincode?.length == 6) {
      pincodeData(formValues.Pincode, "1");
    }
  }, [formValues.Pincode]);

  useEffect(() => {
    if (formValues.ShopPin?.length == 6) {
      pincodeData(formValues.ShopPin, "2");
    }
  }, [formValues.ShopPin]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  useEffect(() => {
    setFormValues(details);
  }, [details]);

  // useEffect(() => {
  //   setFormValues({
  //     ...details,
  //     level_1_parent_code: details?.level_1_parent.toString().split("|")[0],
  //     level_1_parent_name: details?.level_1_parent.toString().split("|")[1],
  //     level_1_parent_mobile: details?.level_1_parent.toString().split("|")[2],
  //     level_2_parent_code: details?.level_2_parent.toString().split("|")[0],
  //     level_2_parent_name: details?.level_2_parent.toString().split("|")[1],
  //     level_2_parent_mobile: details?.level_2_parent.toString().split("|")[2],
  //     sales_code: details?.level_1_parent.toString().split("|")[3],
  //     salepagename: details?.level_1_parent.toString().split("|")[4],
  //     sales_mobile: details?.level_1_parent.toString().split("|")[5],
  //     // user_type: details?.level_1_parent.toString().split("|")[6],
  //   });
  // }, [details]);
  const positionStyle1 = {
    position: "absolute",
    top: -40,
    left: 0,
    fontFamily: "Poppins",
    color: "rgba(255, 255,255, 1)",
  };

  const requestTPin = async (usr_mobile) => {
    try {
      setTransactionLoaderState(true);
      const hash_key = await generateHashKey2(usr_mobile);
      var myHeaders = new Headers();
      myHeaders.append("HASH_KEY", hash_key);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        mobileno: usr_mobile,
        reset_type: "TPIN",
        password: usr_mobile,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_API}/api/Profile/resetpassword.aspx`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "00") {
        swal("Success", "T PIN Requested Successfully", "success");
      } else {
        swal("Failed", "T PIN Requested Failed", "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };

  const requestMPin = async (usr_mobile) => {
    try {
      setTransactionLoaderState(true);
      const hash_key = await generateHashKey2(usr_mobile);
      var myHeaders = new Headers();
      myHeaders.append("HASH_KEY", hash_key);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        mobileno: usr_mobile,
        reset_type: "MPIN",
        password: usr_mobile,
      });
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_API}/api/Profile/resetpassword.aspx`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "00") {
        swal("Success", "M PIN Requested Successfully", "success");
      } else {
        swal("Failed", "M PIN Requested Failed", "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };

  const setModalData = () => {
    // setBillDetails(billDetails);
    setModalOpen2(true);
  };
  const setModalData2 = () => {
    setModalOpen3(true);
  };

  return (
    <>
      {" "}
      <UpdateTariffPlanModal
        isModalOpen={modalOpen2}
        agentId={agentId}
        // billDetails={billDetails}
        // amount={amount}
        setModalOpen2={(modalState) => {
          setModalOpen2(modalState);
        }}
        refresh={() => {
          setModalOpen2(false);
        }}
      />
      <UpdateTariffPlanModal2
        isModalOpen={modalOpen3}
        agentId={agentId}
        // billDetails={billDetails}
        // amount={amount}
        setModalOpen3={(modalState) => {
          setModalOpen3(modalState);
        }}
        refresh={() => {
          setModalOpen3(false);
        }}
      />
      <div className="px-4" style={{ fontFamily: "auto" }}>
        {clickedImageURL && (
          <div
            className="image-overlays"
            onClick={() => setClickedImageURL("")}
          >
            <img src={clickedImageURL} alt="Clicked" />
          </div>
        )}
        {formValues.usr_mobile ? (
          <div>
            <Row className="d-flex justify-content-between align-items-center">
              {/* Profile text */}
              <Col>
                <h4 className="text-primary">
                  <b>My Profile</b>
                </h4>
              </Col>
              <Row>
                <Col md={6} lg={6} sm={12}>
                  <Form.Label className="text-primary">
                    <b>
                      {formValues?.level_1_parent?.toString()?.split("|")[6]}{" "}
                    </b>
                  </Form.Label>
                </Col>
              </Row>
              {/* Buttons */}
              <Col className="d-flex justify-content-end">
                <div className="d-flex gap-3">
                
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={12} className="mb-4">
                <div className="profile-section">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5>
                      <b>Personal Information</b>
                    </h5>
                    <button className="btn btn-link text-primary">Edit</button>
                  </div>
                  <hr />
                  <Row>
                    <Col md={6}>
                      <p>
                        <b>First Name:</b> {formValues.usr_first_name}
                      </p>
                    </Col>
                    <Col md={6}>
                      <p>
                        <b>Last Name:</b> {formValues.usr_last_name}
                      </p>
                    </Col>
                    <Col md={6}>
                      <p>
                        <b>Email Address:</b> {formValues.usr_email}
                      </p>
                    </Col>
                    <Col md={6}>
                      <p>
                        <b>Phone:</b> {formValues.usr_mobile}
                      </p>
                    </Col>
                    <Col md={6}>
                      <p>
                        <b>Gender:</b> {formValues.gender}
                      </p>
                    </Col>
                    <Col md={6}>
                      <p>
                        <b>Date of Birth:</b> {formValues.userdob}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>

              <Col md={12} className="mb-4">
                <div className="profile-section">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5>
                      <b>Address</b>
                    </h5>
                    <button className="btn btn-link text-primary">Edit</button>
                  </div>
                  <hr />
                  <Row>
                    <Col md={6}>
                      <p>
                        <b>Country:</b> {formValues.usr_country}
                      </p>
                    </Col>
                    <Col md={6}>
                      <p>
                        <b>City/State:</b> {formValues.usr_city},{" "}
                        {formValues.usr_state}
                      </p>
                    </Col>
                    <Col md={6}>
                      <p>
                        <b>Postal Code:</b> {formValues.usr_pin_code}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>

              <Col md={12} className="mb-4">
                <div className="profile-section">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5>
                      <b>Shop Details</b>
                    </h5>
                    <button className="btn btn-link text-primary">Edit</button>
                  </div>
                  <hr />
                  <Row>
                    <Col md={6}>
                      <p>
                        <b>Shop Name:</b> {formValues.shop_name}
                      </p>
                    </Col>
                    <Col md={6}>
                      <p>
                        <b>Shop Address:</b> {formValues.shop_address}
                      </p>
                    </Col>
                    <Col md={6}>
                      <p>
                        <b>City/State:</b> {formValues.shop_city},{" "}
                        {formValues.shop_state}
                      </p>
                    </Col>
                    <Col md={6}>
                      <p>
                        <b>Pincode:</b> {formValues.shop_pin_code}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col md={12}>
                <div className="profile-section">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5>
                      <b>Additional Details</b>
                    </h5>
                  </div>
                  <hr />

                  <Row>
                    <Col md={4}>
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="mb-1">
                          <b>Pan Card Number:</b> {formValues.pan_card_no || ""}
                        </p>
                        <button
                          className="btn btn-link text-primary p-0"
                          onClick={() => {
                            setModalData2({
                            });
                          }}
                        >
                          Edit
                        </button>
                      </div>
                    </Col>

                    <Col md={4}>
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="mb-1">
                          <b>Aadhar Card Number:</b>{" "}
                          {formValues.aadhar_card_no || ""}
                        </p>
                        <button
                          className="btn btn-link text-primary p-0"
                          onClick={() => {
                            setModalData({
                              aadhar: formValues.aadhar_card_no,
                              // rch_amount: e.rch_amount,
                              // user_code: e.user_code,
                            });
                          }}
                        >
                          Edit
                        </button>
                      </div>
                    </Col>

                    <Col md={4}>
                      <p>
                        <b>GST Number:</b>{" "}
                        {formValues.gst_number || "Not Provided"}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </div>
        ) : (
          <NoDataFound />
        )}
      </div>
    </>
  );
};

const UpdateTariffPlanModal = ({
  agentId,
  isModalOpen,
  setModalOpen2,
  refresh,
}) => {
  const twoDecimalPlaces = (value) => {
    return Number(value).toFixed(2).toString();
  };
  const { username1, password1 } = adminAuth;
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [aadhar, setAadhar] = useState("");
  const [aadharError, setAadharError] = useState("");

  const handleRemarkChange = (e) => {
    setAadhar(e.target.value);
  };


  const userDetailsUpdate = async () => {
    try {
      setTransactionLoaderState(true);
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
        );

      var raw = JSON.stringify({
        userid: agentId,
        adminId: user.pkid,
        action: "AADHAAR_CHANGE",
        p1: aadhar,
        p2: "",
        p3: "",
        p4: ""
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.USER_DETAIL_UPDATE}`,
        requestOptions
      );
      const data = await res.json();
      if (data.responseCode == "00") {
        cogoToast.success(data.responseMessage);
        refresh();
      } else {
        cogoToast.error(data.responseMessage);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };



  return (
    <Modal
      show={isModalOpen}
      onHide={() => setModalOpen2(false)}
      aria-labelledby="example-modal-sizes-title-md"
      size="s"
    >
 <Modal.Body className="p-0">
  <div
    className="modal-content border-0"
    style={{ borderRadius: "12px" }}
  >
    <div className="modal-header flex-column align-items-start">
      <div className="d-flex justify-content-between w-100">
        <h5 className="modal-title mb-1">Update Aadhar Details</h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => setModalOpen2(false)}
        ></button>
      </div>
      <p className="mb-0 text-muted" style={{ fontSize: "14px" }}>
        Please review the information carefully before making changes.
      </p>
    </div>

    <div className="modal-body text-start">
      <div className="mb-3">
        <label className="form-label">New Aadhar Number</label>

        <input
          type="text"
          value={aadhar}
          placeholder="Enter Aadhar Number"
          maxLength={12}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "").slice(0, 12);
            setAadhar(value);
            setAadharError("");
          }}
          className="form-control"
        />

        {aadharError && (
          <p className="text-danger mt-1" style={{ fontSize: "13px" }}>
            {aadharError}
          </p>
        )}

        {aadhar && aadhar.length < 12 && !aadharError && (
          <p className="text-danger mt-1" style={{ fontSize: "13px" }}>
            Aadhar must be exactly 12 digits
          </p>
        )}

        <small className="text-muted">
          Ensure the entered Aadhar number is accurate. Incorrect details may
          lead to service restrictions.
        </small>
      </div>

      <div
        className="p-2 mt-3"
        style={{
          backgroundColor: "#f4f8ff",
          borderLeft: "4px solid #2f6fed",
          borderRadius: "6px",
          fontSize: "13px",
          color: "#1f3f8b",
        }}
      >
        🔒 Your identity details are protected using industry-standard encryption.
        Changes are logged for security and compliance purposes.
      </div>
    </div>

    <div className="modal-footer d-flex flex-column flex-md-row gap-2">
      <button
        className="btn btn-primary"
        onClick={() => {
          if (!aadhar || aadhar.trim() === "") {
            setAadharError("Please fill the Aadhar field");
            return;
          }

          if (aadhar.length !== 12) {
            setAadharError("Aadhar must be exactly 12 digits");
            return;
          }

          userDetailsUpdate();
        }}
      >
        Update
      </button>

      <button
        className="btn btn-secondary"
        onClick={() => setModalOpen2(false)}
      >
        Cancel
      </button>
    </div>
  </div>
</Modal.Body>

    </Modal>
  );
};

const UpdateTariffPlanModal2 = ({
  agentId,
  isModalOpen,
  setModalOpen3,
  refresh,
}) => {

  const { username1, password1 } = adminAuth;
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [pan, setPan] = useState("");
  const [panError, setPanError] = useState("");
  const handleRemarkChange = (e) => {
    setPan(e.target.value);
  };


  const userDetailsUpdate = async () => {
    try {
      setTransactionLoaderState(true);
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
        );

      var raw = JSON.stringify({
        userid: agentId,
        adminId: user.pkid,
        action: "PAN_CHANGE",
        p1: pan,
        p2: "",
        p3: "",
        p4: ""
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.USER_DETAIL_UPDATE}`,
        requestOptions
      );
      const data = await res.json();
      if (data.responseCode == "00") {
        cogoToast.success(data.responseMessage);
        refresh();
      } else {
        cogoToast.error(data.responseMessage);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };



  return (
    <Modal
      show={isModalOpen}
      onHide={() => setModalOpen3(false)}
      aria-labelledby="example-modal-sizes-title-md"
      size="s"
    >
 <Modal.Body className="p-0">
  <div
    className="modal-content border-0"
    style={{ borderRadius: "12px" }}
  >
    <div className="modal-header flex-column align-items-start">
      <div className="d-flex justify-content-between w-100">
        <h5 className="modal-title mb-1">Update PAN Details</h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => setModalOpen3(false)}
        ></button>
      </div>
      <p className="mb-0 text-muted" style={{ fontSize: "14px" }}>
        Please review the information carefully before making changes.
      </p>
    </div>

    <div className="modal-body text-start">
      <div className="mb-3">
        <label className="form-label">New PAN Number</label>

        <input
          type="text"
          value={pan}
          placeholder="Enter PAN Number"
          maxLength={10}
          onChange={(e) => {
            const value = e.target.value.toUpperCase();
            setPan(value);
            setPanError("");
          }}
          className="form-control"
        />

        {panError && (
          <p className="text-danger mt-1" style={{ fontSize: "13px" }}>
            {panError}
          </p>
        )}

        <small className="text-muted">
          Ensure the entered PAN number is accurate. Incorrect details may lead
          to service restrictions.
        </small>
      </div>

      <div
        className="p-2 mt-3"
        style={{
          backgroundColor: "#f4f8ff",
          borderLeft: "4px solid #2f6fed",
          borderRadius: "6px",
          fontSize: "13px",
          color: "#1f3f8b",
        }}
      >
        🔒 Your identity details are protected using industry-standard encryption.
        Changes are logged for security and compliance purposes.
      </div>
    </div>

    <div className="modal-footer d-flex flex-column flex-md-row gap-2">
      <button
        className="btn btn-primary"
        onClick={() => {
          if (!pan || pan.trim() === "") {
            setPanError("Please fill the PAN field ");
            return;
          }

          userDetailsUpdate();
        }}
      >
        Update
      </button>

      <button
        className="btn btn-secondary"
        onClick={() => setModalOpen3(false)}
      >
        Cancel
      </button>
    </div>
  </div>
</Modal.Body>


    </Modal>
  );
};
const NetworkInfo = ({ details, agentId }) => {
  const [activeTab, setActiveTab] = useState(0);
  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const [offset, setOffset] = useState(10);
  const [dataToDisplay, setDataToDisplay] = useState([]);
  const [pages, setPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [personalDetails, setPersonalDetails] = useState({});

  const { username1, password1 } = adminAuth;
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const history = useHistory();
  const [dob, setDob] = useState(new Date());
  const [kycData, setKycData] = useState({});
  const [WalletBal, setWalletBal] = useState({});
  const [userDetails, setUserDetails] = useState({});
  const [State_Code, setStateCode] = useState([]);
  const [State, setState] = useState("");
  const [City, setCity] = useState("");
  const [verifiedKycData, setVerifiedKycData] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [data, setData] = useState([]);
  const [formValues, setFormValues] = useState({
    mainBal: "",
    AepsBal: "",
    PgBal: "",
    LeinBal: "",
    FirstName: "",
    LastName: "",
    Gender: "",
    DOB: new Date(),
    Mobile: "",
    Email: "",
    Address: "",
    Pincode: "",
    City: "",
    State: "",
    ShopAddress: "",
    ShopPin: "",
    ShopCity: "",
    ShopState: "",
    AdharFront: "",
    AdharBack: "",
    GstDoc: "",
    Userimage: "",
    UserSign: "",
    UserImageWithAdhar: "",
    ShopImage: "",
    ShopName: "",
    Address: "",
    Pincode: "",
    pancardno: "",
    aadharcardno: "",
    gstnumber: "",
    OTP: "",
  });

  const [verification, setVerification] = useState({
    PAN: false,
    ADHAR: false,
    panDetails: null,
    adhaarDetails: null,
    otpSent: false,
    aadhaar_request_id: "",
  });

  const [uploadedDocs, setUploadedDoc] = useState({
    profile: false,
    POI: false,
    POA_Front: false,
    POA_Back: false,
    sign: false,
    gstdoc: false,
  });
  const [clickedImageURL, setClickedImageURL] = useState("");
  const userId = JSON.parse(localStorage.getItem("kyc"));

  const fetchUserKycData = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: userId.pk_user_id,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_API}/api/kyc/fetchkycdata.aspx`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == 0 && data.data.length > 0) {
        if (data.data[0].kyc_status == "P" || data.data[0].kyc_status == "A") {
        }
        setKycData(data.data[0]);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const Datehandler = (date) => {
    setFormValues({ ...formValues, DOB: date });
    const inputDate = new Date(date);
    const currentDate = new Date();
    const eighteenYearsAgo = new Date();
    eighteenYearsAgo.setFullYear(currentDate.getFullYear() - 18);
    if (inputDate <= eighteenYearsAgo) {
    } else {
      setFormErrors({
        ...formErrors,
        DOB: "*Please enter Date before 18 years",
      });
    }
    setDob(date);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const imagePath = `${BASE_URL_API}/users_kyc_doc`;

  const dateToStr = (date) =>
    `${date.getFullYear()}-${
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1
    }-${date.getDate() < 10 ? "0" + date.getDate() : date.getDate()}`;

  const verificationData = async () => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: agentId,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_API}/api/Kyc/fetch_kyc_image_data2.aspx`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
        let selfiWithDoc = "",
          selfiWithEmployee = "";

        if (data.data.relation.includes("|")) {
          selfiWithDoc = data.data.relation.split("|")[0];
          selfiWithEmployee = data.data.relation.split("|")[1];
        }
        let imguser = "";
        if (data.data.imguser != "") {
          imguser = `${imagePath}/${data.data.imguser}.jpeg?v=${uniqueID2()}`;
        }
        let imgpancard = "";
        if (data.data.imgpancard != "") {
          imgpancard = `${imagePath}/${
            data.data.imgpancard
          }.jpeg?v=${uniqueID2()}`;
        }
        let imgaadharfront = "";
        if (data.data.imgaadharfront != "") {
          imgaadharfront = `${imagePath}/${
            data.data.imgaadharfront
          }.jpeg?v=${uniqueID2()}`;
        }
        let imgaadharback = "";
        if (data.data.imgaadharback != "") {
          imgaadharback = `${imagePath}/${
            data.data.imgaadharback
          }.jpeg?v=${uniqueID2()}`;
        }
        let signature = "";
        if (data.data.signature != "") {
          signature = `${imagePath}/${
            data.data.signature
          }.jpeg?v=${uniqueID2()}`;
        }

        let gstdoc = "";
        if (data.data.gstdoc != "") {
          gstdoc = `${imagePath}/${data.data.gstdoc}.jpeg?v=${uniqueID2()}`;
        }

        if (data.data.relation.includes("|")) {
          selfiWithDoc = `${imagePath}/${
            data.data.relation.split("|")[0]
          }.jpeg?v=${uniqueID2()}`;
          selfiWithEmployee = `${imagePath}/${
            data.data.relation.split("|")[1]
          }.jpeg?v=${uniqueID2()}`;
        }

        setUserDetails(data.data);

        setKycData({
          ...kycData,
          imguser,
          imgpancard,
          imgaadharfront,
          imgaadharback,
          signature,
          gstdoc,
          selfiWithDoc,
          selfiWithEmployee,
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const verificationData2 = async () => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: agentId,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API}${API_ENDPOINTS.FETCH_KYC_IMAGE_DATA}`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
        let selfiWithDoc = "",
          selfiWithEmployee = "";

        if (data.data.relation.includes("|")) {
          selfiWithDoc = data.data.relation.split("|")[0];
          selfiWithEmployee = data.data.relation.split("|")[1];
        }
        let imguser = "";
        if (data.data.imguser != "") {
          imguser = `${imagePath}/${data.data.imguser}.jpeg?v=${uniqueID2()}`;
        }
        let imgpancard = "";
        if (data.data.imgpancard != "") {
          imgpancard = `${imagePath}/${
            data.data.imgpancard
          }.jpeg?v=${uniqueID2()}`;
        }
        let imgaadharfront = "";
        if (data.data.imgaadharfront != "") {
          imgaadharfront = `${imagePath}/${
            data.data.imgaadharfront
          }.jpeg?v=${uniqueID2()}`;
        }
        let imgaadharback = "";
        if (data.data.imgaadharback != "") {
          imgaadharback = `${imagePath}/${
            data.data.imgaadharback
          }.jpeg?v=${uniqueID2()}`;
        }
        let signature = "";
        if (data.data.signature != "") {
          signature = `${imagePath}/${
            data.data.signature
          }.jpeg?v=${uniqueID2()}`;
        }

        let gstdoc = "";
        if (data.data.gstdoc != "") {
          gstdoc = `${imagePath}/${data.data.gstdoc}.jpeg?v=${uniqueID2()}`;
        }

        if (data.data.relation.includes("|")) {
          selfiWithDoc = `${imagePath}/${
            data.data.relation.split("|")[0]
          }.jpeg?v=${uniqueID2()}`;
          selfiWithEmployee = `${imagePath}/${
            data.data.relation.split("|")[1]
          }.jpeg?v=${uniqueID2()}`;
        }

        setKycData({
          ...kycData,
          imguser,
          imgpancard,
          imgaadharfront,
          imgaadharback,
          signature,
          gstdoc,
          selfiWithDoc,
          selfiWithEmployee,
        });

        setUserDetails(data.data);

        setFormValues({
          ...formValues,
          ShopName: data.data.shopname,
          FirstName: data.data.userfname,
          LastName: data.data.userlname,
          Gender: data.data.gender,
          DOB: new Date(data.data.dateofbirth),
          Mobile: data.data.usermobile,
          Email: data.data.emailid,
          Address: data.data.useraddress,
          ShopAddress: data.data.shopaddress,
          Pincode: data.data.statecode,
          ShopPin: data.data.shoppincode,
          ShopCity: data.data.shopcity,
          ShopState: data.data.shopstate,
          City: data.data.usercity,
          State: data.data.userstate,
          pancardno: data.data?.pancardno,
          aadharcardno: data.data?.aadharcardno,
          gstnumber: data.data?.gstnumber,
        });

        setUploadedDoc({
          profile: data.data.imguser ? true : false,
          POI: data.data.imgpancard ? true : false,
          POA_Front: data.data.imgaadharfront ? true : false,
          POA_Back: data.data.imgaadharback ? true : false,
          sign: data.data.signature ? true : false,
          gstdoc: data.data.gstdoc ? true : false,
        });

        setVerifiedKycData(data.data);
        setVerification({
          ...verification,
          PAN: data.data.pan_verified == "Y",
          panDetails: data.data.pan_verified_name,
          ADHAR: data.data.aadhaar_verified == "Y",
          adhaarDetails: data.data,
        });
      } else {
        setFormValues({
          FirstName: "",
          LastName: "",
          Gender: "",
          DOB: new Date(),
          Mobile: "",
          Email: "",
          Address: "",
          Pincode: "",
          City: "",
          State: "",
          ShopAddress: "",
          ShopPin: "",
          ShopCity: "",
          ShopState: "",
          AdharFront: "",
          AdharBack: "",
          GstDoc: "",
          Userimage: "",
          UserSign: "",
          UserImageWithAdhar: "",
          ShopImage: "",
          ShopName: "",
          Address: "",
          Pincode: "",
          pancardno: "",
          aadharcardno: "",
          gstnumber: "",
          OTP: "",
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const insertVerifiedKycData = async (
    pan_verified,
    aadhaar_verified,
    pan_verified_name,
    aadhaar_verified_dob,
    aadhaar_verified_address,
    shop_and_home_address_check
  ) => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userID: userId.pk_user_id,
        pan_verified: pan_verified,
        aadhaar_verified: aadhaar_verified,
        pan_verified_name: pan_verified_name,
        aadhaar_verified_dob: aadhaar_verified_dob,
        aadhaar_verified_address: aadhaar_verified_address,
        shop_and_home_address_check: shop_and_home_address_check,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        `${BASE_URL_API}/api/Apitranxt/kyc/insert_verified_kyc_data`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => console.log(result))
        .catch((error) => console.log("error", error));
    } catch (error) {}
  };

  const pincodeData = (pincode, type) => {
    console.log({ pincode, type });
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      pincode: pincode,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      setTransactionLoaderState(true);
      fetch(
        `${BASE_URL_API}${API_ENDPOINTS.PIN_DATA}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.length > 0) {
            setCity(result[0].city);
            setState(result[0].state);
            if (type == "1") {
              setFormValues({
                ...formValues,
                City: result[0].city,
                State: result[0].state,
              });
            } else if (type == "2") {
              setFormValues({
                ...formValues,
                ShopCity: result[0].city,
                ShopState: result[0].state,
              });
            }
          }
          setTransactionLoaderState(false);
        })
        .catch((err) => {
          setTransactionLoaderState(false);
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (agentId && agentId.length > 4) {
      verificationData2();
    }
  }, [agentId]);

  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const level2ParentData = personalDetails.level_2_parent
  ? personalDetails.level_2_parent.split("|")
  : [];
  const level1Data = personalDetails.level_1_parent
  ? personalDetails.level_1_parent.split("|")
  : [];

const level2ParentCode = level2ParentData[0] || "NA";
const level2ParentName = level2ParentData[1] || "NA";
const level2ParentMobile = level2ParentData[2] || "NA";
const level1ParentCode = level1Data[0] || "NA";    
const level1ParentName = level1Data[1] || "NA";    
const level1ParentMobile = level1Data[2] || "NA";   

// Sales Person
const salesCode = level1Data[3] || "NA";           
const salesName = level1Data[4] || "NA";         
const salesMobile = level1Data[5] || "NA";          

  // const MN = sessionStorage.getItem("MN");

  const convertToBiteArray = (file, callback) => {
    const reader = new FileReader();
    const fileByteArray = [];
    reader.readAsArrayBuffer(file);
    reader.onloadend = (evt) => {
      if (evt.target.readyState === FileReader.DONE) {
        const arrayBuffer = evt.target.result,
          array = new Uint8Array(arrayBuffer);
        var binary = "";
        var len = array.byteLength;
        for (var i = 0; i < len; i++) {
          binary += String.fromCharCode(array[i]);
        }
        callback(window.btoa(binary));
      }
    };
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      // Doc();
    }
  }, [formErrors]);

  const validate = (values) => {
    const errors = {};
    if (!uploadedDocs.POI) {
      errors.PAN = "*Pan is required!";
    }
    if (!uploadedDocs.POA_Front) {
      errors.AdharFront = "*Adhar Front is required";
    }
    if (!uploadedDocs.POA_Back) {
      errors.AdharBack = "*Adhar Back is required!";
    }
    if (!uploadedDocs.profile) {
      errors.Userimage = "*User image is required";
    }
    if (!uploadedDocs.sign) {
      errors.UserSign = "*User Sign is required";
    }
    return errors;
  };

  useEffect(() => {
    if (formValues.Pincode?.length == 6) {
      pincodeData(formValues.Pincode, "1");
    }
  }, [formValues.Pincode]);

  useEffect(() => {
    if (formValues.ShopPin?.length == 6) {
      pincodeData(formValues.ShopPin, "2");
    }
  }, [formValues.ShopPin]);

  const getWalletBalance = async () => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: agentId,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.GET_WALLET_BAL}`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
        setWalletBal({
          mainBal: data.data?.wallet_bal || "",
          AepsBal: data.data?.aeps_settlement_bal || "",
          PgBal: data.data?.pg_settlement_bal || "",
          LeinBal: data.data?.lean_amount || "",
        });
      }
    } catch (error) {
      console.error("Error fetching wallet data:", error);
    }
  };
  console.log("formValues", formValues);

  const getProviderList = async () => {
    try {
      setTransactionLoaderState(true);
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userID: agentId,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API}${API_ENDPOINTS.DIST_GET_PROVIDER_LIST}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status == "0" && result.data) {
            setData(result.data);
            setDataToDisplay(result.data);
            setTransactionLoaderState(false);
          } else {
            setData([]);
            setTransactionLoaderState(false);
          }
        })
        .catch((error) => console.log("error", error));
    } catch (error) {
      console.log(error);
    }
  };



  const fetchData = () => {
    getProviderList(startDate, endDate);
  };

  const positionStyle1 = {
    position: "absolute",
    top: -38,
    left: 0,
    fontFamily: "Poppins",
    color: "rgba(255, 255,255, 1)",
  };

  const ProfileDetails = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
        );
      console.log("test1");

      var raw = JSON.stringify({
        UserID: agentId,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.GET_USER_VIEW_PROFILE}`,
        requestOptions
      );
      const data = await res.json();

      if (data.responseCode === "00") {
        setPersonalDetails(data.data);
        console.log("Data mapped successfully");
      } else {
        swal(
          "User Not Found",
          "Please Enter Valid ID Or Mobile number",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    getProviderList();
    ProfileDetails();
  }, []);
  console.log(agentId);

  return (
    <div className="px-2 py-0" style={{ fontFamily: "auto" }}>
      {clickedImageURL && (
        <div className="image-overlays" onClick={() => setClickedImageURL("")}>
          <img src={clickedImageURL} alt="Clicked" />
        </div>
      )}
   <Row className="mt-2">
  <Col lg={4} md={6} sm={12} className="mb-3">
    <Card
      className="p-3 h-100"
      style={{
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        border: "none",
      }}
    >
      <Form.Label className="text-primary" style={{ fontSize: "0.95rem" }}>
        <b>Level 1 Parent</b>
      </Form.Label>

      <Form.Label style={{ fontSize: "0.85rem" }}>
        <b>Code :</b> {level1ParentCode}
      </Form.Label>

      <Form.Label style={{ fontSize: "0.85rem" }}>
        <b>Name :</b> {level1ParentName}
      </Form.Label>

      <Form.Label style={{ fontSize: "0.85rem" }}>
        <b>Mobile :</b> {level1ParentMobile}
      </Form.Label>
    </Card>
  </Col>

  <Col lg={4} md={6} sm={12} className="mb-3">
    <Card
      className="p-3 h-100"
      style={{
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        border: "none",
      }}
    >
      <Form.Label className="text-primary" style={{ fontSize: "0.95rem" }}>
        <b>Level 2 Parent</b>
      </Form.Label>

      <Form.Label style={{ fontSize: "0.85rem" }}>
        <b>Code :</b> {level2ParentCode}
      </Form.Label>

      <Form.Label style={{ fontSize: "0.85rem" }}>
        <b>Name :</b> {level2ParentName}
      </Form.Label>

      <Form.Label style={{ fontSize: "0.85rem" }}>
        <b>Mobile :</b> {level2ParentMobile}
      </Form.Label>
    </Card>
  </Col>

  <Col lg={4} md={6} sm={12} className="mb-3">
    <Card
      className="p-3 h-100"
      style={{
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        border: "none",
      }}
    >
      <Form.Label className="text-primary" style={{ fontSize: "0.95rem" }}>
        <b>Sales Person</b>
      </Form.Label>

      <Form.Label style={{ fontSize: "0.85rem" }}>
        <b>Code :</b> {salesCode}
      </Form.Label>

      <Form.Label style={{ fontSize: "0.85rem" }}>
        <b>Name :</b> {salesName}
      </Form.Label>

      <Form.Label style={{ fontSize: "0.85rem" }}>
        <b>Mobile :</b> {salesMobile}
      </Form.Label>
    </Card>
  </Col>
</Row>


      <div>
        <div className="row m-0 p-0  pt-1 align-items-center">
          <div className="col-3 m-0 p-0">
            <div
              className="m-0 p-0 pl-3 align-top"
              style={{
                fontFamily: "Poppins",
                fontWeight: "600",
                lineHeight: "48px",
                letterSpacing: "0em",
                textAlign: "left",
                padding: "0px",
                background: "#FFFFFF",
                color: "#4267B2",
                fontWeight: "bolder",
                fontfamily: "Poppins !impotent",
                fontSize: "28px",
              }}
            >
              Provider List
            </div>
          </div>

          <div className="col-9 m-0 p-0 ">
            <div className="row m-0 p-0 justify-content-end">
              <div
                className="pr-1 pl-2 p-0 m-0"
                style={{ width: "18%", height: "20%" }}
              >
                <Form.Group className="p-0 m-0">
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    className="form-control rounded-100"
                    placeholderText="Start Date"
                  />
                </Form.Group>
              </div>
              <div
                className="px-1 p-0 m-0"
                style={{ width: "18%", height: "20%" }}
              >
                <Form.Group className="p-0 m-0">
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    className="form-control rounded-100"
                    placeholderText="End Date"
                  />
                </Form.Group>
              </div>

              <div
                className="pl-1 p-0 m-0"
                style={{ width: "14%", height: "20%" }}
              >
                <Form.Group className="mt-0 p-0 m-0">
                  <Button
                    className=" btn btn-primary btn-lg btn-block "
                    style={{
                      background: "#4267B2",
                      color: "white",
                    }}
                    onClick={fetchData}
                  >
                    {"Search"}
                  </Button>
                </Form.Group>
              </div>
            </div>
          </div>
        </div>

        <hr className="m-0 p-0" />

        <div style={{ width: "100%" }}>
          <div style={{ alignItems: "center" }}>
            <div style={{ flex: "1" }}></div>
          </div>
        </div>
        <div style={{ overflowX: "auto", width: "100%" }}>
          <table
            className="my-table transparent-table text-center border-bottom"
            style={{
              width: "100%",
              overflowX: "auto",
              border: "0px",
              overflow: "auto",
            }}
          >
            <tr className="borderless-table text-center border-bottom">
              <th
                className="my-table transparent-table text-center border-bottom "
                style={{
                  fontFamily: "Poppins",
                  fontSize: "16px",
                  fontWeight: "700",
                  lineHeight: "24px",
                  letterSpacing: "0em",
                  textAlign: "center",
                }}
              >
                {"Sr"}
              </th>
              <th
                className="my-table transparent-table text-center border-bottom "
                style={{
                  fontFamily: "Poppins",
                  fontSize: "16px",
                  fontWeight: "700",
                  lineHeight: "24px",
                  letterSpacing: "0em",
                  textAlign: "center",
                }}
              >
                User ID
              </th>
              <th
                className="my-table transparent-table text-center border-bottom "
                style={{
                  fontFamily: "Poppins",
                  fontSize: "16px",
                  fontWeight: "700",
                  lineHeight: "24px",
                  letterSpacing: "0em",
                  textAlign: "center",
                }}
              >
                User
              </th>

              <th
                className="my-table transparent-table text-center border-bottom "
                style={{
                  fontFamily: "Poppins",
                  fontSize: "16px",
                  fontWeight: "700",
                  lineHeight: "24px",
                  letterSpacing: "0em",
                  textAlign: "center",
                }}
              >
                Shop Name
              </th>
              <th
                className="my-table transparent-table text-center border-bottom "
                style={{
                  fontFamily: "Poppins",
                  fontSize: "16px",
                  fontWeight: "700",
                  lineHeight: "24px",
                  letterSpacing: "0em",
                  textAlign: "center",
                }}
              >
                Balance
              </th>
              <th
                className="my-table transparent-table text-center border-bottom "
                style={{
                  fontFamily: "Poppins",
                  fontSize: "16px",
                  fontWeight: "700",
                  lineHeight: "24px",
                  letterSpacing: "0em",
                  textAlign: "center",
                }}
              >
                Status
              </th>
              <th
                className="my-table transparent-table text-center border-bottom "
                style={{
                  fontFamily: "Poppins",
                  fontSize: "16px",
                  fontWeight: "700",
                  lineHeight: "24px",
                  letterSpacing: "0em",
                  textAlign: "center",
                }}
              >
                Date
              </th>
            </tr>
            {dataToDisplay.map((e, ind) => (
              <tr className="border-bottom">
                <td
                  className="text-center border-bottom"
                  style={{
                    fontSize: "0.8rem",
                    fontFamily: "Poppins",
                    fontWeight: "400",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  {ind + 1}
                </td>
                <td
                  className="text-center border-bottom"
                  style={{
                    fontSize: "0.8rem",
                    fontFamily: "Poppins",
                    fontWeight: "400",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  <div>{e.pk_user_id}</div>
                </td>

                <td
                  className="text-center border-bottom"
                  style={{
                    fontSize: "0.8rem",
                    fontFamily: "Poppins",
                    fontWeight: "400",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  <div>{e.us_code}</div>
                  <div>{e.us_loginid}</div>
                </td>
                <td
                  className="text-center border-bottom"
                  style={{
                    fontSize: "0.8rem",
                    fontFamily: "Poppins",
                    fontWeight: "400",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  <div>{e.us_shop_name}</div>
                </td>

                <td
                  className="text-center  text-bold border-bottom"
                  style={{
                    fontSize: "0.8rem",
                    fontFamily: "Poppins",
                    fontWeight: "400",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  <div>{e.userbalance}</div>
                </td>
                <td
                  className="text-center border-bottom"
                  style={{
                    fontSize: "0.8rem",
                    fontFamily: "Poppins",
                    fontWeight: "400",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  <div>{e.kycstatus}</div>
                </td>

                <td
                  className="text-center border-bottom"
                  style={{
                    fontSize: "0.8rem",
                    fontFamily: "Poppins",
                    fontWeight: "400",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  {e.us_create_date}
                </td>
              </tr>
            ))}
          </table>
          <Pagination
            page={currentPage}
            limit={pages}
            callback={(page) => {
              setCurrentPage(page);
            }}
            count={dataToDisplay.length}
            total={total}
            callback2={(offsetValue) => {
              setOffset(offsetValue);
            }}
          />
        </div>
      </div>
    </div>
  );
};

const BankInfo = ({ details, agentId, refresh }) => {
  const { username1, password1 } = adminAuth;
  const [activeTab, setActiveTab] = useState(0);
  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  const [personalDetails, setPersonalDetails] = useState({});
  const [aepsSettlementAccounts, setAepsSettlementAccounts] = useState([]);
  const [pgSettlementAccounts, setPgSettlementAccounts] = useState([]);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const history = useHistory();
  const [dob, setDob] = useState(new Date());
  const [kycData, setKycData] = useState({});
  const [WalletBal, setWalletBal] = useState({});
  const [userDetails, setUserDetails] = useState({});
  // const [agentId, setAgentId] = useState("");
  const [dataToDisplay, setDataToDisplay] = useState([]);
  const [State_Code, setStateCode] = useState([]);
  const [State, setState] = useState("");
  const [City, setCity] = useState("");
  const [verifiedKycData, setVerifiedKycData] = useState(null);
  const [formValues, setFormValues] = useState({
    mainBal: "",
    AepsBal: "",
    PgBal: "",
    LeinBal: "",
    FirstName: "",
    LastName: "",
    Gender: "",
    DOB: new Date(),
    Mobile: "",
    Email: "",
    Address: "",
    Pincode: "",
    City: "",
    State: "",
    ShopAddress: "",
    ShopPin: "",
    ShopCity: "",
    ShopState: "",
    AdharFront: "",
    AdharBack: "",
    GstDoc: "",
    Userimage: "",
    UserSign: "",
    UserImageWithAdhar: "",
    ShopImage: "",
    ShopName: "",
    Address: "",
    Pincode: "",
    pancardno: "",
    aadharcardno: "",
    gstnumber: "",
    OTP: "",
  });
  const [searchText, setSearchText] = useState("");
  const searchBarStyle = {
    display: "flex",
    alignItems: "center",
    border: "1px solid #ccc",
    borderRadius: "6px",
    padding: "0px",
    backgroundColor: "#fff",
    width: "25%", // Adjust the width as needed
    height: "20%",
  };
  const now = (date = new Date()) => {
    return `${date.getFullYear()}-${
      date.getMonth() > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
    }-${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()}`;
  };

  const [verification, setVerification] = useState({
    PAN: false,
    ADHAR: false,
    panDetails: null,
    adhaarDetails: null,
    otpSent: false,
    aadhaar_request_id: "",
  });

  const [uploadedDocs, setUploadedDoc] = useState({
    profile: false,
    POI: false,
    POA_Front: false,
    POA_Back: false,
    sign: false,
    gstdoc: false,
  });
  const [clickedImageURL, setClickedImageURL] = useState("");
  const userId = JSON.parse(localStorage.getItem("kyc"));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const imagePath = `${BASE_URL_API}/users_kyc_doc`;

  const dateToStr = (date) =>
    `${date.getFullYear()}-${
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1
    }-${date.getDate() < 10 ? "0" + date.getDate() : date.getDate()}`;

  const verificationData2 = async () => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: agentId,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API}${API_ENDPOINTS.FETCH_KYC_IMAGE_DATA}`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
        let selfiWithDoc = "",
          selfiWithEmployee = "";

        if (data.data.relation.includes("|")) {
          selfiWithDoc = data.data.relation.split("|")[0];
          selfiWithEmployee = data.data.relation.split("|")[1];
        }
        let imguser = "";
        if (data.data.imguser != "") {
          imguser = `${imagePath}/${data.data.imguser}.jpeg?v=${uniqueID2()}`;
        }
        let imgpancard = "";
        if (data.data.imgpancard != "") {
          imgpancard = `${imagePath}/${
            data.data.imgpancard
          }.jpeg?v=${uniqueID2()}`;
        }
        let imgaadharfront = "";
        if (data.data.imgaadharfront != "") {
          imgaadharfront = `${imagePath}/${
            data.data.imgaadharfront
          }.jpeg?v=${uniqueID2()}`;
        }
        let imgaadharback = "";
        if (data.data.imgaadharback != "") {
          imgaadharback = `${imagePath}/${
            data.data.imgaadharback
          }.jpeg?v=${uniqueID2()}`;
        }
        let signature = "";
        if (data.data.signature != "") {
          signature = `${imagePath}/${
            data.data.signature
          }.jpeg?v=${uniqueID2()}`;
        }

        let gstdoc = "";
        if (data.data.gstdoc != "") {
          gstdoc = `${imagePath}/${data.data.gstdoc}.jpeg?v=${uniqueID2()}`;
        }

        if (data.data.relation.includes("|")) {
          selfiWithDoc = `${imagePath}/${
            data.data.relation.split("|")[0]
          }.jpeg?v=${uniqueID2()}`;
          selfiWithEmployee = `${imagePath}/${
            data.data.relation.split("|")[1]
          }.jpeg?v=${uniqueID2()}`;
        }

        setKycData({
          ...kycData,
          imguser,
          imgpancard,
          imgaadharfront,
          imgaadharback,
          signature,
          gstdoc,
          selfiWithDoc,
          selfiWithEmployee,
        });

        setUserDetails(data.data);

        setFormValues({
          ...formValues,
          ShopName: data.data.shopname,
          FirstName: data.data.userfname,
          LastName: data.data.userlname,
          Gender: data.data.gender,
          DOB: new Date(data.data.dateofbirth),
          Mobile: data.data.usermobile,
          Email: data.data.emailid,
          Address: data.data.useraddress,
          ShopAddress: data.data.shopaddress,
          Pincode: data.data.statecode,
          ShopPin: data.data.shoppincode,
          ShopCity: data.data.shopcity,
          ShopState: data.data.shopstate,
          City: data.data.usercity,
          State: data.data.userstate,
          pancardno: data.data?.pancardno,
          aadharcardno: data.data?.aadharcardno,
          gstnumber: data.data?.gstnumber,
        });

        setUploadedDoc({
          profile: data.data.imguser ? true : false,
          POI: data.data.imgpancard ? true : false,
          POA_Front: data.data.imgaadharfront ? true : false,
          POA_Back: data.data.imgaadharback ? true : false,
          sign: data.data.signature ? true : false,
          gstdoc: data.data.gstdoc ? true : false,
        });

        setVerifiedKycData(data.data);
        setVerification({
          ...verification,
          PAN: data.data.pan_verified == "Y",
          panDetails: data.data.pan_verified_name,
          ADHAR: data.data.aadhaar_verified == "Y",
          adhaarDetails: data.data,
        });
      } else {
        setFormValues({
          FirstName: "",
          LastName: "",
          Gender: "",
          DOB: new Date(),
          Mobile: "",
          Email: "",
          Address: "",
          Pincode: "",
          City: "",
          State: "",
          ShopAddress: "",
          ShopPin: "",
          ShopCity: "",
          ShopState: "",
          AdharFront: "",
          AdharBack: "",
          GstDoc: "",
          Userimage: "",
          UserSign: "",
          UserImageWithAdhar: "",
          ShopImage: "",
          ShopName: "",
          Address: "",
          Pincode: "",
          pancardno: "",
          aadharcardno: "",
          gstnumber: "",
          OTP: "",
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const pincodeData = (pincode, type) => {
    console.log({ pincode, type });
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      pincode: pincode,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      setTransactionLoaderState(true);
      fetch(
        `${BASE_URL_API}${API_ENDPOINTS.PIN_DATA}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.length > 0) {
            setCity(result[0].city);
            setState(result[0].state);
            if (type == "1") {
              setFormValues({
                ...formValues,
                City: result[0].city,
                State: result[0].state,
              });
            } else if (type == "2") {
              setFormValues({
                ...formValues,
                ShopCity: result[0].city,
                ShopState: result[0].state,
              });
            }
          }
          setTransactionLoaderState(false);
        })
        .catch((err) => {
          setTransactionLoaderState(false);
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (agentId && agentId.length > 4) {
      verificationData2();
    }
  }, [agentId]);

  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  // const MN = sessionStorage.getItem("MN");

  useEffect(() => {
    if (formValues.Pincode?.length == 6) {
      pincodeData(formValues.Pincode, "1");
    }
  }, [formValues.Pincode]);

  useEffect(() => {
    if (formValues.ShopPin?.length == 6) {
      pincodeData(formValues.ShopPin, "2");
    }
  }, [formValues.ShopPin]);

  const iconStyle = {
    color: "rgba(0, 0, 0, 0.5)",
  };

  const inputStyle = {
    border: "none",
    outline: "none",
    backgroundColor: "transparent",
    fontSize: "16px",
    marginLeft: "8px",
    width: "100%",
    fontFamily: "Poppins",
    fontWeight: "400",
  };

  // const handleChange = (e) => {
  // const { name, value } = e.target;
  // setFormValues({
  // ...formValues,
  // [name]: value,
  // });
  // };

  useEffect(() => {
    setPersonalDetails(details.personalDetails);
    setAepsSettlementAccounts(details.aepsSettlementAccounts);
    setPgSettlementAccounts(details.pgSettlementAccounts);
  }, [
    details.aepsSettlementAccounts,
    details.pgSettlementAccounts,
    details.personalDetails,
  ]);

  const refundVerification = (
    bank_holder_name,
    bank_name,
    account_number,
    id
  ) => {
    swal({
      title: "Are you sure?",
      text: `Are you sure you want to delete this account?\n\nAccount Holder: ${bank_holder_name}\nBank Name: ${bank_name}\nAccount Number: ${account_number}`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        console.log("hwlo");

        userDetailsUpdate(id);
      }
    });
  };
  const setAccountPrimary = (
    bank_holder_name,
    bank_name,
    account_number,
    id
  ) => {
    swal({
      title: "Are you sure?",
      text: `Are you sure you want to make this account primary ?\n\nAccount Holder: ${bank_holder_name}\nBank Name: ${bank_name}\nAccount Number: ${account_number}`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        console.log("hwlo");

        setUserAccountPrimary(id);
      }
    });
  };
  const userDetailsUpdate = async (id) => {
    try {
      setTransactionLoaderState(true);
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
        );

      var raw = JSON.stringify({
        userid: agentId,
        adminId: user.pkid,
        action: "AEPS_ACCOUNT_DELETE",
        p1: id,
        p2: "string",
        p3: "string",
        p4: "string",
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.USER_DETAIL_UPDATE}`,
        requestOptions
      );
      const data = await res.json();
      if (data.responseCode == "00") {
        cogoToast.success(data.responseMessage);
        refresh();
      } else {
        swal("Failed", data.responseMessage, "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };

  const setUserAccountPrimary = async (id) => {
    try {
      setTransactionLoaderState(true);
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
        );

      var raw = JSON.stringify({
        adminId: user.pkid,
        bankAccountId: id,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.setAepsBankAccountPrimary}`,
        requestOptions
      );
      const data = await res.json();
      if (data.responseCode == "00") {
        cogoToast.success(data.responseMessage);
        refresh();
      } else {
        swal("Failed", data.responseMessage, "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };

  return (
    <div className="p-4" style={{ fontFamily: "auto" }}>
      <div>
        <Row>
          <Col md={3} lg={3} sm={6} className="mt-2">
            <Card className="p-2">
              <Form.Label className="text-primary">
                <b>Main Account</b>
              </Form.Label>
              <Form.Label>
                <b>Balance:</b> {personalDetails.user_balance}
              </Form.Label>
            </Card>
          </Col>

          <Col md={3} lg={3} sm={6} className="mt-2">
            <Card className="p-2">
              <Form.Label className="text-primary">
                <b>AEPS Account</b>
              </Form.Label>
              <Form.Label>
                <b>Balance:</b> {personalDetails.user_aeps_balance}
              </Form.Label>
            </Card>
          </Col>

          <Col md={3} lg={3} sm={6} className="mt-2">
            <Card className="p-2">
              <Form.Label className="text-primary">
                <b>PG Account</b>
              </Form.Label>
              <Form.Label>
                <b>Balance:</b> {personalDetails.user_pg_balance}
              </Form.Label>
            </Card>
          </Col>

          <Col md={3} lg={3} sm={6} className="mt-2">
            <Card className="p-2">
              <Form.Label className="text-primary">
                <b>Lein Amount</b>
              </Form.Label>
              <Form.Label>
                <b>Balance:</b> {personalDetails.user_lean_balance}
              </Form.Label>
            </Card>
          </Col>
        </Row>

        <div>
          <div>
            <div>
              <div className="row m-0 p-0 pt-1 align-items-center">
                <div className="col-4 m-0 p-0">
                  <div
                    className="m-0 p-0 pl-2"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "32px",
                      fontWeight: "600",
                      lineHeight: "48px",
                      letterSpacing: "0em",
                      textAlign: "left",
                      padding: "0px",
                      background: "#FFFFFF",
                      color: "#4267B2",
                      fontWeight: "bolder",
                      fontfamily: "Poppins !impotent",
                      fontSize: "28px",
                    }}
                  >
                    AEPS Settlement Banks
                  </div>
                </div>

                <div className="col-8 m-0 p-0 "></div>
              </div>
              <hr className="m-0 p-0" />
            </div>
          </div>

          <div className="scroll-inner ">
            <table
              className="my-table transparent-table text-center border-bottom"
              style={{
                width: "100%",
                overflowX: "auto",
                border: "0px",
                overflow: "auto",
              }}
            >
              <tr className="borderless-table text-center border-bottom">
                <th
                  className="my-table transparent-table text-center border-bottom py-3"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  {"ID"}
                </th>

                <th
                  className="my-table transparent-table text-center border-bottom "
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  {"Bank Name"}
                </th>
                <th
                  className="my-table transparent-table text-center border-bottom "
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  {"Bank Account Number"}
                </th>
                <th
                  className="my-table transparent-table text-center border-bottom "
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  {"IFSC Code"}
                </th>
                <th
                  className="my-table transparent-table text-center border-bottom "
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  {"Bank Holder Name"}
                </th>
                <th
                  className="my-table transparent-table text-center border-bottom "
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  {"Account Type"}
                </th>
                <th
                  className="my-table transparent-table text-center border-bottom "
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  {"Action"}
                </th>
              </tr>
              {aepsSettlementAccounts.map((e, ind) => (
                <tr className="border-bottom">
                  <td
                    className="text-center border-bottom"
                    style={{
                      fontSize: "0.8rem",
                      fontFamily: "Poppins",
                      fontWeight: "400",
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "center",
                    }}
                  >
                    <div>{e.id}</div>
                  </td>
                  <td
                    className="text-center border-bottom"
                    style={{
                      fontSize: "0.8rem",
                      fontFamily: "Poppins",
                      fontWeight: "400",
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "center",
                    }}
                  >
                    <div>{e.bank_name}</div>
                  </td>
                  <td
                    className="text-center border-bottom"
                    style={{
                      fontSize: "0.8rem",
                      fontFamily: "Poppins",
                      fontWeight: "400",
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "center",
                    }}
                  >
                    <div>{e.account_number}</div>
                  </td>
                  <td
                    className="text-center border-bottom"
                    style={{
                      fontSize: "0.8rem",
                      fontFamily: "Poppins",
                      fontWeight: "400",
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "center",
                    }}
                  >
                    <div>{e.ifsc_code}</div>
                  </td>
                  <td
                    className="text-center border-bottom"
                    style={{
                      fontSize: "0.8rem",
                      fontFamily: "Poppins",
                      fontWeight: "400",
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "center",
                    }}
                  >
                    <div>{e.bank_holder_name}</div>
                  </td>
                  <td
                    className="text-center border-bottom"
                    style={{
                      fontSize: "0.8rem",
                      fontFamily: "Poppins",
                      fontWeight: "400",
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "center",
                    }}
                  >
                    <div>{e.isPrimary}</div>
                  </td>
                  <td
                    className="text-center border-bottom"
                    style={{
                      fontSize: "0.8rem",
                      fontFamily: "Poppins",
                      fontWeight: "400",
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "center",
                    }}
                  >
                    <button
                      className="btn btn-block bg-danger "
                      style={{
                        border: "none",
                        color: "white",
                        borderRadius: "15px",
                      }}
                      onClick={() => {
                        refundVerification(
                          e.bank_holder_name,
                          e.bank_name,
                          e.account_number,
                          e.id
                        );
                      }}
                    >
                      Delete{" "}
                    </button>
                    <button
                      className="btn btn-block bg-primary m-1 "
                      style={{
                        border: "none",
                        color: "white",
                        borderRadius: "15px",
                      }}
                      onClick={() => {
                        setAccountPrimary(
                          e.bank_holder_name,
                          e.bank_name,
                          e.account_number,
                          e.id
                        );
                      }}
                    >
                      Set Primary{" "}
                    </button>
                  </td>
                </tr>
              ))}
            </table>
          </div>
        </div>

        <div>
          <div>
            <div>
              <div className="row m-0 p-0 pt-1 align-items-center">
                <div className="col-4 m-0 p-0">
                  <div
                    className="m-0 p-0 pl-2"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "32px",
                      fontWeight: "600",
                      lineHeight: "48px",
                      letterSpacing: "0em",
                      textAlign: "left",
                      padding: "0px",
                      background: "#FFFFFF",
                      color: "#4267B2",
                      fontWeight: "bolder",
                      fontfamily: "Poppins !impotent",
                      fontSize: "28px",
                    }}
                  >
                    PG Settlement Banks
                  </div>
                </div>

                <div className="col-8 m-0 p-0 "></div>
              </div>
              <hr className="m-0 p-0" />
            </div>
          </div>

          <div className="scroll-inner ">
            <table
              className="my-table transparent-table text-center border-bottom"
              style={{
                width: "100%",
                overflowX: "auto",
                border: "0px",
                overflow: "auto",
              }}
            >
              <tr className="borderless-table text-center border-bottom">
                <th
                  className="my-table transparent-table text-center border-bottom py-3"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  {"Sr"}
                </th>

                <th
                  className="my-table transparent-table text-center border-bottom "
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  {"Action"}
                </th>
                <th
                  className="my-table transparent-table text-center border-bottom "
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  {"Action"}
                </th>
                <th
                  className="my-table transparent-table text-center border-bottom "
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  {"Action"}
                </th>
              </tr>
              {details.pgSettlementAccounts.map((e, ind) => (
                <tr className="border-bottom"></tr>
              ))}
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

const ImagesData = ({ details, agentId }) => {
  const [activeTab, setActiveTab] = useState(0);
  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const history = useHistory();
  const [dob, setDob] = useState(new Date());
  const [kycData, setKycData] = useState({});
  const [WalletBal, setWalletBal] = useState({});
  const [userDetails, setUserDetails] = useState({});
  const [State_Code, setStateCode] = useState([]);
  const [State, setState] = useState("");
  const [City, setCity] = useState("");
  const [verifiedKycData, setVerifiedKycData] = useState(null);
  const [formValues, setFormValues] = useState(details);

  const [verification, setVerification] = useState({
    PAN: false,
    ADHAR: false,
    panDetails: null,
    adhaarDetails: null,
    otpSent: false,
    aadhaar_request_id: "",
  });

  const [uploadedDocs, setUploadedDoc] = useState({
    profile: false,
    POI: false,
    POA_Front: false,
    POA_Back: false,
    sign: false,
    gstdoc: false,
  });
  const [clickedImageURL, setClickedImageURL] = useState("");
  const userId = JSON.parse(localStorage.getItem("kyc"));

  const imagePath = `${BASE_URL_API}/users_kyc_doc`;

  const dateToStr = (date) =>
    `${date.getFullYear()}-${
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1
    }-${date.getDate() < 10 ? "0" + date.getDate() : date.getDate()}`;

  const updateUserDetails = async () => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        fkuserid: agentId,
        shopname: formValues.ShopName,
        shopaddress: formValues.ShopAddress,
        shoppincode: formValues.ShopPin,
        shopcity: formValues.ShopCity,
        shopstate: formValues.ShopState,
        userfname: formValues.FirstName,
        userlname: formValues.LastName,
        usermobile: formValues.Mobile,
        useraddress: formValues.Address,
        userpincode: formValues.Pincode,
        usercity: formValues.City,
        userstate: formValues.State,
        emailid: formValues.Email,
        statecode: formValues.StateCode,
        gender: formValues.Gender,
        dateofbirth: dateToStr(formValues.DOB),
        pancardno: formValues.pancardno,
        aadharcardno: formValues.aadharcardno,
        gstnumber: formValues.gstnumber,
        nomineename: "",
        relation: "",
        nomineeaadhar: "",
        //
        imgpancard: `${formValues.Mobile}_POI`,
        imgaadharfront: `${formValues.Mobile}_POA_Front`,
        imgaadharback: `${formValues.Mobile}_POA_Back`,
        gstdoc: `${formValues.Mobile}_gst`,
        imguser: `${formValues.Mobile}_profile`,
        signature: `${formValues.Mobile}_sign`,
        //
        nomineeage: "",
        passport: "",
        adminId: user.pkid,
        userName: "",
        userMobile: formValues.Mobile,
        ipaddress: "192.168.1.1",
        location: "Noida",
        userFirstName: formValues.FirstName,
        userLastName: formValues.LastName,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API}/api/Apitranxt/admin_user_details_edit`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
        swal("Success", "User Details Updated Successfully", "success");
      } else {
        swal("Failed", "User Details Updation Failed", "error");
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  // const MN = sessionStorage.getItem("MN");

  const convertToBiteArray = (file, callback) => {
    const reader = new FileReader();
    const fileByteArray = [];
    reader.readAsArrayBuffer(file);
    reader.onloadend = (evt) => {
      if (evt.target.readyState === FileReader.DONE) {
        const arrayBuffer = evt.target.result,
          array = new Uint8Array(arrayBuffer);
        var binary = "";
        var len = array.byteLength;
        for (var i = 0; i < len; i++) {
          binary += String.fromCharCode(array[i]);
        }
        callback(window.btoa(binary));
      }
    };
  };

  const ImageUpload = (e, agentid) => {
    console.log(userDetails);
    if (!userDetails.usermobile) {
      return;
    }
    let MN = userDetails.usermobile;
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    const type = e.target.id;

    if (e.target.files.length > 0) {
      if (e.target.files[0].size > 256000) {
        swal("Invalid", "Image Size should be less than 256 kb", "error");
        return;
      }
      convertToBiteArray(e.target.files[0], (ByteArray) => {
        var raw = JSON.stringify({
          imagename: `${MN}_${type}`,
          imagebytedata: ByteArray,
          type: "string",
          agentid: agentid,
        });

        var requestOptions = {
          method: "POST",
          body: raw,
          redirect: "follow",
        };

        try {
          fetch(
            `${BASE_URL_API}${API_ENDPOINTS.IMAGE_UPLOAD}`,
            requestOptions
          )
            .then((response) => response.json())
            .then((result) => {
              if (result.status == "0") {
                setUploadedDoc({ ...uploadedDocs, [type]: true });
                cogoToast.success(result.msg);
                // verificationData();
              } else {
                cogoToast.error(result.msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } catch (error) {
          console.log(error);
        }
      });
    }
  };

  useEffect(() => {
    setKycData(details);
  }, [details]);

  return (
    <div className="p-4" style={{ fontFamily: "auto" }}>
      {clickedImageURL && (
        <div className="image-overlays" onClick={() => setClickedImageURL("")}>
          <img src={clickedImageURL} alt="Clicked" />
        </div>
      )}

      <Row>
        <Row className="col-12">
          <Col className="col-12 col-sm-6 col-md-4 text-left">
            <Form.Label className="text-left">
              <b className="text-left">Passport Size Photo</b>
              <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Image
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "30vh",
                maxWidth: "30vw",
              }}
              onClick={() => {
                setClickedImageURL(kycData.passport_pic);
              }}
              src={kycData.passport_pic}
            ></Image>
            <Form.Control
              accept=".jpg,.png"
              type="file"
              name="Userimage"
              value={formValues.Userimage}
              id="profile"
              onChange={ImageUpload}
              sty
              className="mt-3 mx-auto text-center row justify-content-center m-0 p-0"
            />
            <p style={{ color: "red" }}>{formErrors.Userimage}</p>
          </Col>

          <Col className="col-12 col-sm-6 col-md-4 text-left">
            <Form.Label>
              <b>Pan Card</b>
              <span style={{ color: "red" }}>*</span>
            </Form.Label>

            <Image
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "30vh",
                maxWidth: "30vw",
              }}
              onClick={() => {
                setClickedImageURL(kycData.img_pan_card);
              }}
              src={kycData.img_pan_card}
            ></Image>

            <Form.Control
              className="mt-3"
              accept=".jpg,.png"
              type="file"
              name="PAN"
              value={formValues.PAN}
              id="POI"
              onChange={ImageUpload}
            />
            <p style={{ color: "red" }}>{formErrors.PAN}</p>
          </Col>

          <Col className="col-12 col-sm-6 col-md-4 text-left">
            <Form.Label>
              <b>Adhar Card Front Side</b>
              <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Image
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "30vh",
                maxWidth: "30vw",
              }}
              onClick={() => {
                setClickedImageURL(kycData.img_aadhar_front);
              }}
              src={kycData.img_aadhar_front}
            ></Image>
            <Form.Control
              className="mt-3"
              accept=".jpg,.png"
              type="file"
              name="AdharFront"
              value={formValues.AdharFront}
              id="POA_Front"
              onChange={ImageUpload}
            />
            <p style={{ color: "red" }}>{formErrors.AdharFront}</p>
          </Col>
        </Row>

        <Row className="mt-2 col-12">
          <Col className="col-12 col-sm-6 col-md-4 text-left">
            <Form.Label>
              <b>Adhar Card Back Side</b>
              <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Image
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "30vh",
                maxWidth: "30vw",
              }}
              onClick={() => {
                setClickedImageURL(kycData.img_aadhar_back);
              }}
              src={kycData.img_aadhar_back}
            ></Image>
            <Form.Control
              className="mt-3"
              accept=".jpg,.png"
              type="file"
              name="AdharBack"
              value={formValues.AdharBack}
              id="POA_Back"
              onChange={ImageUpload}
            />
            <p style={{ color: "red" }}>{formErrors.AdharBack}</p>
          </Col>
          <Col className="col-12 col-sm-6 col-md-4 text-left">
            <Form.Label>
              <b>Signature</b>
              <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Image
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "30vh",
                maxWidth: "30vw",
              }}
              onClick={() => {
                setClickedImageURL(kycData.signature_pic);
              }}
              src={kycData.signature_pic}
            ></Image>
            <Form.Control
              className="mt-3"
              accept=".jpg,.png"
              type="file"
              name="UserSign"
              value={formValues.UserSign}
              id="sign"
              onChange={ImageUpload}
            />
            <p style={{ color: "red" }}>{formErrors.UserSign}</p>
          </Col>

          <Col md={3} lg={3} sm={6} className="text-left">
            <Form.Label>
              <b>Shop Image</b>
            </Form.Label>
            <Image
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "30vh",
                maxWidth: "30vw",
              }}
              onClick={() => {
                setClickedImageURL(kycData.pdf_gst_doc);
              }}
              src={kycData.pdf_gst_doc}
            ></Image>
            <Form.Control
              className="mt-3"
              accept=".jpg,.png"
              type="file"
              name="gst"
              value={formValues.ShopImage}
              id="gst"
              onChange={ImageUpload}
            />
          </Col>

          <Col className="col-12 col-sm-6 col-md-4 text-left">
            <Form.Label>
              <b>LIVE PHOTO WITH DOCUMENTS </b>
            </Form.Label>
            <Image
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "30vh",
                maxWidth: "30vw",
              }}
              onClick={() => {
                setClickedImageURL(kycData.selfi_with_doc);
              }}
              src={kycData.selfi_with_doc}
            ></Image>
            <Form.Control
              accept=".jpg,.png"
              type="file"
              name="selfiWithDoc"
              value={formValues.selfiWithDoc}
              id="selfiWithDoc"
              onChange={ImageUpload}
            />
          </Col>
          <Col className="col-12 col-sm-6 col-md-4 text-left">
            <Form.Label>
              <b>AGENT WITH EMPLOYEE PHOTO</b>
            </Form.Label>
            <Image
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "30vh",
                maxWidth: "30vw",
              }}
              onClick={() => {
                setClickedImageURL(kycData.selfi_with_employee);
              }}
              src={kycData.selfi_with_employee}
            ></Image>
            <Form.Control
              accept=".jpg,.png"
              type="file"
              name="selfiWithEmployee"
              value={formValues.selfiWithEmployee}
              id="selfiWithEmployee"
              onChange={ImageUpload}
            />
          </Col>
        </Row>
        <Col md={3} lg={3} sm={6} className="mt-4">
          <Button
            className="btn-block"
            variant="success"
            onClick={updateUserDetails}
          >
            Submit
          </Button>
        </Col>
      </Row>
    </div>
  );
};

const Pagination = ({ page, limit, callback, total, count, callback2 }) => {
  console.table({ page, limit, callback });
  return (
    <div
      className="row"
      style={{
        display: "flex",
        alignItems: "end",
        width: "100%",
        margin: "10px 0px",
        justifyContent: "space-between",
      }}
    >
      <div>
        <strong>{`Showing ${count} of ${total} entries`}</strong>
      </div>
      <div className="d-flex">
        <select
          className="form-control"
          aria-label="offset"
          onChange={(e) => {
            callback2(e.target.value);
          }}
        >
          {offsetArr.map((offset) => (
            <option value={offset}>{offset}</option>
          ))}
        </select>
        {page - 2 > 0 ? (
          <Button
            onClick={() => {
              callback(page - 1);
            }}
            variant="light"
          >
            {"Previous"}
          </Button>
        ) : null}

        {page - 1 > 0 ? (
          <Button
            onClick={() => {
              callback(page - 1);
            }}
            variant="light"
          >
            {" "}
            {(page - 1).toString()}
          </Button>
        ) : null}
        <Button variant="primary"> {page.toString()}</Button>
        {page + 1 <= limit ? (
          <Button
            onClick={() => {
              callback(page + 1);
            }}
            variant="light"
          >
            {"Next"}
          </Button>
        ) : null}
      </div>
    </div>
  );
};
